import { initializeApp } from "firebase/app";
import { getDatabase, ref, get, set, onValue, child } from "firebase/database";
import {firebaseConfig} from "/src/firebaseConfig.js";

const app = initializeApp(firebaseConfig)
const db = getDatabase(app)
const PATH="diplomagic/";

function modelToPersistence(model){
    return {
        "searchText": model.searchText,
        "searchFilter": model.searchFilter,
        "quizHistory": model.quizHistory,
    };
}

function persistenceToModel(data, model) {
    model.setSearchText(data?.searchText)
    for(const key in data?.searchFilter){
        model.setSearchFilter(key, data?.searchFilter[key])
    }
    //data?.quizHistory?.forEach((history) =>  model.setQuizHistory(history))
    model.setQuizHistory(data?.quizHistory)
  }
  

function saveToFirebase(model) {
  if(!model.userID) return 
  if (model.ready) {
    set(ref(db, PATH+`/${model.userID}`), modelToPersistence(model));
  }
}

// function fetchData() {
//   return get(ref(auth, PATH));
// }

// function updateModel(data, model) {
//   return persistenceToModel(data, model)
//     .then(() => {
//       model.ready = true;
//     });
// }

// function fetchError(error) {
//   console.error('error', error);
//   throw error;
// }


function readFromFirebase(model) {
    
    if(!model.userID) return 
    
    model.ready = false;
    

    return get(ref(db, PATH+`/${model.userID}`))
        .then(function convertACB(snapshot){
            return persistenceToModel(snapshot.val(), model);
        })
        .then(function setModelReadyACB(){
            model.ready=true;
        })
        .then(function setonValueListenerACB(){
            
            const dbRef = ref(db, PATH+`/${model.userID}`)
            onValue(dbRef, function onValueChangeACB(snapshot){
                persistenceToModel(snapshot.val(), model)
            })
            // onValue(child(dbRef, 'numberOfGuests'), (snapshot) => model.setNumberOfGuests(snapshot.val() || 2));
            // onValue(child(dbRef, "currentDishId"), (snapshot) => model.setCurrentDishId(snapshot.val() || null));
            // onValue(child(dbRef, 'dishes'), 
            //     (snapshot) => {getMenuDetails(snapshot.val() || []).then((dishes) => model.dishes = dishes)})
            
        })
}

function connectToFirebase(model, watchFunction){

    readFromFirebase(model)
    watchFunction(checkForChangesACB, performEffectACB);

    function checkForChangesACB(){
        return [model.searchText, model.changeFlag];
    }
   
    function performEffectACB(){
        saveToFirebase(model);
    }
}

export { connectToFirebase, modelToPersistence, persistenceToModel, saveToFirebase, readFromFirebase, app }
